import type {
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';
import LabelT from '../Label/LabelT';
import NumberInputT from './NumberInputT';

type NumberInputWithLabelProps<T extends FieldValues> = {
  field?: Path<T>;
  placeholder?: string;
  options?: RegisterOptions<T>;
  control?: Control<T>;
  label: string;
  id?: string;
  labelClassName?: string;
  parentClassName?: string;
  emptyAsUndefined?: boolean;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export function NumberInputWithLabelT<T extends FieldValues>({
  field,
  placeholder,
  options,
  control,
  label,
  id,
  labelClassName = '',
  parentClassName = '',
  ...restParams
}: NumberInputWithLabelProps<T>) {
  const { disabled } = options || {};

  return (
    <>
      <LabelT
        text={label}
        htmlFor={id}
        className={`${labelClassName} ${disabled ? 'pointer-events-none' : ''}`}
      />
      <div className='mt-1'>
        <NumberInputT
          id={id}
          placeholder={placeholder}
          field={field}
          control={control}
          options={options}
          parentClassName={parentClassName}
          {...restParams}
        />
      </div>
    </>
  );
}

export default NumberInputWithLabelT;
